/**
 * @type {string}
 * @description - Empty results component.
 */
export const EMPTY_RESULTS_WEB_COMPONENT = 'empty-results-component';
